// Legal-page copy is tens of kilobytes and is not used on the Masuren
// homepage. It stays out of the first payload and is merged back when the
// route actually needs it.
export const MASUREN_DEFERRED_TRANSLATION_DOMAINS = [
  'page.datenschutz',
  'page.datenschutz.harz_sauerland',
  'page.agb',
  'page.agb.harz_sauerland',
  'page.bewertungsrichtlinien',
  'page.bewertungsrichtlinien.harz_sauerland',
  'page.impressum'
] as const

export function masurenPathNeedsTranslationDomain (path: string, domain: string): boolean {
  if (domain.startsWith('page.datenschutz')) {
    return path.startsWith('/datenschutz')
  }
  if (domain.startsWith('page.agb')) {
    return path.startsWith('/agb')
  }
  if (domain.startsWith('page.bewertungsrichtlinien')) {
    return path.includes('bewertung')
  }
  if (domain === 'page.impressum') {
    return path.startsWith('/impressum')
  }
  return false
}
